const routes = [
    {
        path: "/prep/bulk/import",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
        }
    }
];

export default routes;
